document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth <= 1000;
    const desktopVideos = document.querySelectorAll(".desktop-video-pd-off video");
    const mobileVideos = document.querySelectorAll(".mobile-video-reel-pd-off video");

    const allVideos = [...desktopVideos, ...mobileVideos];

    const playVideoIfInViewport = (video) => {
        const rect = video.getBoundingClientRect();
        // Check if the video is at least partially in the viewport
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            if (video.paused) {
                video.muted = true;
                video.playsInline = true;
                video.setAttribute("webkit-playsinline", "true");
                video.play().catch(() => {});
            }
        }
    };

    // Immediately check if videos are in the viewport when the page loads
    allVideos.forEach(playVideoIfInViewport);

    // Create an IntersectionObserver to handle scroll events after page load
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;
            const isDesktopVideo = video.closest('.desktop-video-pd-off') !== null;
            const isMobileVideo = video.closest('.mobile-video-reel-pd-off') !== null;

            const shouldLoadAndPlay = (
                (isMobile && isMobileVideo) || (!isMobile && isDesktopVideo)
            );

            if (entry.intersectionRatio >= 0.5 && shouldLoadAndPlay && video.readyState >= 2) {
                if (video.paused) {
                    video.muted = true;
                    video.playsInline = true;
                    video.setAttribute("webkit-playsinline", "true");
                    video.play().catch(() => {});
                }
            } else {
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }, {
        threshold: [0.05, 0.5]
    });

    allVideos.forEach(video => {
        observer.observe(video);
    });
});

// iOS Chrome/Safari unlock on first gesture
document.addEventListener("touchstart", () => {
  const targetVideos = document.querySelectorAll(
    ".desktop-video-pd-off video, .mobile-video-reel-pd-off video"
  );
  
  targetVideos.forEach(video => {
    if (video.paused) {
      video.muted = true;
      video.setAttribute("playsinline", "true");
      video.setAttribute("webkit-playsinline", "true");
      video.play().catch(()=>{});
    }
  });
}, { once: true });
